import { useCallback } from "react";

import { useGetRolesNew } from "@vega-api/generated/auth-permission-v1/auth-permission-v1";

import { useRevokeRoles } from "./useRevokeRoles";
import { useSetRoles } from "./useSetRoles";

/**
 * Core roles hook for mutations and role lookup. For role options filtered by
 * UI context, use useRolesForContext(roleContext) instead — it passes context
 * to /roles-new so the BE can filter roles and compute customizable correctly.
 */
export const useRoles = () => {
  const { isLoading: isLoadingRoles, data: roles } = useGetRolesNew();
  const {
    setRoleNoSubject,
    setRoleBySubject,
    setRoleBySubjectWithCustomPermissions,
    isPendingUpdateUserAndPermissions,
  } = useSetRoles();
  const { revokeRole, isPendingRevokeRole } = useRevokeRoles();

  const getRoleById = useCallback(
    (roleId: string) => roles?.data?.find((role) => role.id === roleId),
    [roles?.data],
  );

  return {
    setRoleNoSubject,
    setRoleBySubject,
    setRoleBySubjectWithCustomPermissions,
    roles,
    isLoadingRoles,
    revokeRole,
    deleteRole: revokeRole,
    isPendingRoleActions:
      isPendingUpdateUserAndPermissions || isPendingRevokeRole,
    getRoleById,
  };
};
